// extracted by extract-css-chunks-webpack-plugin
module.exports = {"colorBox":"ColorBox__colorBox___1N5Bh","colorLine":"ColorBox__colorLine___wZ8Zz","square":"ColorBox__square___3k9sW","isNotSelectable":"ColorBox__isNotSelectable___3D8GV","theSelectedColor":"ColorBox__theSelectedColor___2unqO","noSelection":"ColorBox__noSelection___2nA-M","isUsed":"ColorBox__isUsed___iDafN"};
    if(module.hot) {
      // 1751719784423
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  